import { memberGQLFields } from '../network/index.js';
const BASIC_MODERATION_ITEM_REPORTER_FIELDS = {
    reporter: 'basic',
};
const ALL_MODERATION_ITEM_REPORTER_FIELDS = {
    reporter: 'all',
};
export const moderationItemReporterGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_MODERATION_ITEM_REPORTER_FIELDS;
    if (fields === 'all')
        fields = ALL_MODERATION_ITEM_REPORTER_FIELDS;
    return `
    createdAt
    description
    id
    reportCategory
    updatedAt
    ${fields.reporter
        ? `
      reporter {
        ${memberGQLFields(fields.reporter)}
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=moderationItemReporter.fields.js.map